import classNames from 'clsx';
import React, { forwardRef, memo, useImperativeHandle } from 'react';
import { useActiveSteps } from 'reactApp/sections/Nestle/hooks/useActiveSteps';

import styles from './VerticalSteps.css';

const steps = [1, 2, 3, 4];

export const VerticalSteps = memo(
    forwardRef<HTMLDivElement[]>((_, ref) => {
        const activeSteps: number[] = useActiveSteps();

        const stepRefs = React.useRef<(HTMLDivElement | null)[]>([]);

        useImperativeHandle(ref, () => stepRefs.current as HTMLDivElement[], []);

        return (
            <div className={styles.root}>
                <div className={styles.wrapper}>
                    {steps.map((step, index) => (
                        <div
                            key={step}
                            className={styles.stepBlock}
                            ref={(el) => {
                                stepRefs.current[index] = el;
                            }}
                        >
                            <div
                                className={classNames(styles.circle, {
                                    [styles.circleActive]: activeSteps.includes(step),
                                })}
                            >
                                {step}
                            </div>

                            {index !== steps.length - 1 && <div className={`${styles.line} ${styles[`line${index + 1}`]}`} />}
                        </div>
                    ))}
                </div>
            </div>
        );
    })
);

VerticalSteps.displayName = 'VerticalSteps';
